<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex shrink style="text-align: right"
          ><v-btn
            @click="printPage()"
            dark
            style="width: 80px; background-color: black"
            ><v-icon>local_printshop</v-icon></v-btn
          ></v-flex
        >
        <!-- Nevigater -->
        <v-layout mb-12 v-if="$route.query.name === 'verify-rf'">
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>ตรวจสอบแบบฟอร์ม RF</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย</span>
          </v-flex>
        </v-layout>
        <v-layout v-else mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout>
              <v-flex>
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: left; font-size: 28px; color: white"
                  >
                    <div style="font-weight: bold">
                      รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย
                    </div>
                    <div style="font-size: 18px">Progress Report Form</div>
                  </v-flex>
                  <v-flex
                    ml-8
                    pt-8
                    pr-8
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 13px;
                      color: white;
                    "
                  >
                    <span>RF 03_2562</span>
                  </v-flex>
                </v-layout>

                <!-- blog 1 -->
                <v-card class="mb-12 px-12">
                  <v-layout py-12 pr-12 mr-12>
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout pt-8 pb-6>
                        <v-flex
                          xs2
                          mr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>รหัสโครงร่างการวิจัย</span>
                        </v-flex>
                        <v-flex d-flex align-center xs4>
                          <textfield-form
                            hide-detail
                            :model="form.researchCode"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อผู้วิจัยหลัก</span>
                        </v-flex>
                        <v-flex d-flex align-center xs4>
                          <textfield-form
                            hide-detail
                            :model="form.firstName"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex
                          xs2
                          pr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>นามสกุล</span>
                        </v-flex>
                        <v-flex d-flex align-center xs4>
                          <textfield-form
                            hide-detail
                            :model="form.lastName"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout pb-6>
                        <v-flex
                          d-flex
                          align-center
                          xs2
                          mr-4
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อโครงการวิจัย (ไทย)</span>
                        </v-flex>
                        <v-flex xs10>
                          <textarea-form
                            hide-detail
                            :model="form.researchName"
                            readonly
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>วันที่รับรองครั้งสุดท้าย</span>
                        </v-flex>
                        <v-flex xs3>
                          <textfield-form
                            hide-detail
                            :model="lastDay"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 5 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>วันที่เริ่มเก็บข้อมูล</span>
                        </v-flex>
                        <v-flex xs3>
                          <textfield-form
                            hide-detail
                            :model="startDay"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-checkbox
                          color="#3E7662"
                          readonly
                          v-model="form.hasStartDay"
                          v-bind:true-value="true"
                          v-bind:false-value="false"
                          style="margin-left: 25px; margin-top: 2px;"
                          label="ยังไม่ได้เริ่มเก็บข้อมูล"
                        ></v-checkbox>
                      </v-layout>
                      <!-- row 6 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>วันสิ้นสุดอายุการรับรอง</span>
                        </v-flex>
                        <v-flex xs3>
                          <textfield-form
                            hide-detail
                            :model="endDay"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 7 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          d-flex
                          align-center
                          justify-end
                          style="text-align: right; font-weight: bold"
                        >
                          <span>วันที่ส่งรายงานความก้าวหน้า</span>
                        </v-flex>
                        <v-flex d-flex align-center xs3>
                          <textfield-form
                            hide-detail
                            :model="reportDate"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- blog 2 -->
                <v-layout pt-12 pb-4 mt-12 style="background-color: white">
                  <v-flex>
                    <!-- row 1 -->
                    <v-layout style="padding-left: 100px">
                      <v-flex justify-start d-flex>
                        <span style="font-weight: bold; font-size: 16px"
                          >เวลาการส่งรายงาน</span
                        >
                        {{ form.reportTime }}
                      </v-flex>
                    </v-layout>
                    <v-layout style="padding-left: 30vh">
                      <v-flex justify-start d-flex>
                        <v-radio-group
                          readonly
                          v-model="form.reportTime"
                          hide-details
                        >
                          <!-- <v-radio color="#3E7662" style="padding-right: 100px" label="มากกว่า 30 วัน ก่อนหมดอายุการรับรอง" value="1"></v-radio> -->
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ภายใน 30 วัน ก่อนหมดอายุการรับรอง"
                            value="1"
                          ></v-radio>
                          <!-- <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="ภายหลังหมดอายุการรับรอง"
                        value="3"
                      ></v-radio> -->
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ภายหลังหมดอายุการรับรอง"
                            value="2"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout style="padding-left: 34vh">
                      <v-flex justify-start d-flex>
                        <span style="color: #cc3d45">
                          (วันที่ส่งรายงาน ต้องไม่มากกว่า 60 วัน
                          ก่อนวันหมดอายุการรับรอง)
                        </span>
                      </v-flex>
                    </v-layout>

                    <!-- row 2 -->
                    <v-layout mt-12 style="padding-left: 100px">
                      <v-flex justify-start d-flex>
                        <span style="font-weight: bold; font-size: 16px"
                          >การขอต่ออายุการรับรองโครงร่างการวิจัย</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout style="padding-left: 30vh">
                      <v-flex justify-start d-flex>
                        <v-radio-group
                          readonly
                          v-model="form.wantRenew"
                          hide-details
                        >
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ขอต่ออายุการรับรอง"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ไม่ขอ เนื่องจากการวิจัยสิ้นสุดแล้ว"
                            value="2"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <!-- row 3 -->
                    <!-- <v-layout mt-12 style="padding-left: 100px;">
                  <v-flex justify-start d-flex style="font-weight: bold">
                    <v-checkbox
                      readonly
                      color="#3E7662"
                      label="อื่นๆ ระบุ"
                      v-model="form.hasOther"
                    />
                  </v-flex>
                </v-layout> -->

                    <!-- row 4 Blog Tatle -->
                    <v-layout ma-12>
                      <v-flex>
                        <!-- Header -->
                        <v-layout
                          py-4
                          style="background-color: #3e7662; color: white"
                        >
                          <v-flex xs6>
                            <span>1. จำนวนอาสาสมัคร (ค + ง + จ + ฉ = ข)</span>
                          </v-flex>
                          <v-flex xs6>
                            <span>ข้อคิดเห็น</span>
                          </v-flex>
                        </v-layout>

                        <!-- Card 1 -->
                        <v-card outlined>
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer">Trial Progress</span>
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout px-8 pt-6 pb-4>
                                <v-flex xs5>
                                  <v-checkbox
                                    readonly
                                    color="#3E7662"
                                    label="1. วางแผนไว้"
                                    v-model="form.hasPlan"
                                  />
                                </v-flex>
                                <v-flex pl-6>
                                  <textarea-form
                                    hide-detail
                                    :rows="2"
                                    :disabled="form.hasPlan === false"
                                    :background-color="
                                      form.hasPlan === false
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.plan"
                                    readonly
                                  ></textarea-form>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                px-8
                                pt-6
                                pb-4
                                style="background-color: #fbf6f3"
                              >
                                <v-flex xs5>
                                  <v-checkbox
                                    readonly
                                    color="#3E7662"
                                    label="2. คัดเลือกเข้าในการวิจัย"
                                    v-model="form.hasScreen"
                                  />
                                </v-flex>
                                <v-flex pl-6>
                                  <textarea-form
                                    hide-detail
                                    :rows="2"
                                    :disabled="form.hasScreen === false"
                                    :background-color="
                                      form.hasScreen === false
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.screen"
                                    readonly
                                  ></textarea-form>
                                </v-flex>
                              </v-layout>
                              <!-- row 3 -->
                              <v-layout px-8 pt-6 pb-4>
                                <v-flex xs5>
                                  <v-checkbox
                                    readonly
                                    color="#3E7662"
                                    label="3. อยู่ในระหว่างดำเนินการวิจัย (มีการทำหัตถการหรือการทดลอง)"
                                    v-model="form.hasResearching"
                                  />
                                </v-flex>
                                <v-flex pl-6>
                                  <textarea-form
                                    hide-detail
                                    :rows="2"
                                    :disabled="form.hasResearching === false"
                                    :background-color="
                                      form.hasResearching === false
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.researching"
                                    readonly
                                  ></textarea-form>
                                </v-flex>
                              </v-layout>
                              <!-- row 4 -->
                              <v-layout
                                px-8
                                pt-6
                                pb-4
                                style="background-color: #fbf6f3"
                              >
                                <v-flex xs5>
                                  <v-checkbox
                                    readonly
                                    color="#3E7662"
                                    label="4. อยู่ในระหว่างการติดตามเท่านั้น"
                                    v-model="form.hasFollowing"
                                  />
                                </v-flex>
                                <v-flex pl-6>
                                  <textarea-form
                                    hide-detail
                                    :rows="2"
                                    :disabled="form.hasFollowing === false"
                                    :background-color="
                                      form.hasFollowing === false
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.following"
                                    readonly
                                  ></textarea-form>
                                </v-flex>
                              </v-layout>
                              <!-- row 5 -->
                              <v-layout px-8 pt-6 pb-4>
                                <v-flex xs5>
                                  <v-checkbox
                                    readonly
                                    color="#3E7662"
                                    label="5. ถอนตัว หรือขาดการติดตาม (รวมที่เสียชีวิต)"
                                    v-model="form.hasWithdraw"
                                  />
                                </v-flex>
                                <v-flex pl-6>
                                  <textarea-form
                                    hide-detail
                                    :rows="2"
                                    :disabled="form.hasWithdraw === false"
                                    :background-color="
                                      form.hasWithdraw === false
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.withdraw"
                                    readonly
                                  ></textarea-form>
                                </v-flex>
                              </v-layout>
                              <!-- row 6 -->
                              <v-layout
                                px-8
                                pt-6
                                pb-4
                                style="background-color: #fbf6f3"
                              >
                                <v-flex xs5>
                                  <v-checkbox
                                    readonly
                                    color="#3E7662"
                                    label="6. สิ้นสุดการวิจัย"
                                    v-model="form.hasFinish"
                                  />
                                </v-flex>
                                <v-flex pl-6>
                                  <textarea-form
                                    hide-detail
                                    :rows="2"
                                    :disabled="form.hasFinish === false"
                                    :background-color="
                                      form.hasFinish === false
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.finish"
                                    readonly
                                  ></textarea-form>
                                </v-flex>
                              </v-layout>
                              <!-- row 7 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="
                                        text-align: left;
                                        color: white;
                                        font-weight: bold;
                                      "
                                    >
                                      <span
                                        >2. มีอาสาสมัครถอนตัวจากการวิจัย
                                        ในช่วงการรับรองของคณะอนุกรรมการฯ
                                        ไม่?</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasWithdrawVolunteer"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout pl-4>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span
                                        >(ถ้ามี สรุปจำนวนและระบุเหตุผล)</span
                                      >
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="
                                          form.hasWithdrawVolunteer !== '1'
                                        "
                                        :background-color="
                                          form.hasWithdrawVolunteer !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.withdrawVolunteer"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <!-- Card 2 -->
                        <v-card outlined class="mt-8">
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer"
                                >Protocol Related Documents</span
                              >
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="
                                        text-align: left;
                                        color: white;
                                        font-weight: bold;
                                      "
                                    >
                                      <span
                                        >3. มีส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย
                                        ในช่วงการรับรองของคณะอนุกรรมการฯหรือไม่</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasEdit"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout pl-4>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span>(ถ้ามี สรุปสั้นๆ)</span>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasEdit !== '1'"
                                        :background-color="
                                          form.hasEdit !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.edit"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #fff"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="
                                        text-align: left;
                                        font-weight: bold;
                                      "
                                    >
                                      <span
                                        >4. มีการเปลี่ยนแปลงคู่มือผู้วิจัย
                                        (investigator’s
                                        brochure)ในช่วงการรับรอง</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasEditBrochure"
                                        hide-details
                                        row
                                      >
                                        <v-radio
                                          color="#39896B"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout pl-4>
                                    <v-flex xs8 style="text-align: left">
                                      <span>ของคณะอนุกรรมการฯหรือไม่?</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 3 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="
                                        text-align: left;
                                        color: white;
                                        font-weight: bold;
                                      "
                                    >
                                      <span
                                        >5. มีข้อมูลใหม่ที่เกี่ยวข้องกับการวิจัย
                                        ในช่วงการรับรองของคณะอนุกรรมการฯหรือไม่?</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasNewInformation"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout pl-4>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span>(ถ้ามี สรุปสั้นๆ)</span>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="
                                          form.hasNewInformation !== '1'
                                        "
                                        :background-color="
                                          form.hasNewInformation !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.newInformation"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <!-- Card 3 -->
                        <v-card outlined class="mt-8">
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer">Risk&Benefit</span>
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span
                                        ><b
                                          >6.
                                          มีปัญหาเกี่ยวกับงานวิจัยที่เพิ่มความเสี่ยงต่ออาสาสมัครในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่? </b
                                        >(ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasIssue"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasIssue !== '1'"
                                        :background-color="
                                          form.hasIssue !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.issue"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #fff"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex xs8 style="text-align: left">
                                      <span
                                        ><b
                                          >7.
                                          มีการเปลี่ยนแปลงอัตราส่วนของความเสี่ยงต่อประโยชน์ในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่
                                        </b>
                                        (ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasChangeRatio"
                                        hide-details
                                        row
                                      >
                                        <v-radio
                                          color="#39896B"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasChangeRatio !== '1'"
                                        :background-color="
                                          form.hasChangeRatio !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.changeRatio"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <!-- Card 4 -->
                        <v-card outlined class="mt-8">
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer">Informed consent</span>
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span
                                        ><b
                                          >8.
                                          มีการเปลี่ยนแปลงเอกสารชี้แจงข้อมูลแก่อาสาสมัคร
                                          ในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่? </b
                                        >(ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasChangeDocument"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="
                                          form.hasChangeDocument !== '1'
                                        "
                                        :background-color="
                                          form.hasChangeDocument !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.changeDocument"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #fff"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex xs8 style="text-align: left">
                                      <span
                                        ><b
                                          >9.
                                          มีปัญหาในกระบวนการขอความยินยอมจากอาสาสมัครในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่?
                                        </b>
                                        (ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasConsentIssue"
                                        hide-details
                                        row
                                      >
                                        <v-radio
                                          color="#39896B"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasConsentIssue !== '1'"
                                        :background-color="
                                          form.hasConsentIssue !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.consentIssue"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <!-- Card 5 -->
                        <v-card outlined class="mt-8">
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer">local issues</span>
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span
                                        ><b
                                          >10.
                                          มีเรื่องร้องเรียนของอาสาสมัครเกี่ยวกับโครงการวิจัยจากอาสาในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่? </b
                                        >(ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasComplaint"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasComplaint !== '1'"
                                        :background-color="
                                          form.hasComplaint !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.complaint"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #fff"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex xs8 pr-4 style="text-align: left">
                                      <span
                                        ><b
                                          >11. มีผลกระทบในด้านทัศนคติเชิงลบ
                                          ของชุมชนต่อโครงการวิจัย
                                          ในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่ ?
                                        </b>
                                        (ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasBadEffect"
                                        hide-details
                                        row
                                      >
                                        <v-radio
                                          color="#39896B"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasBadEffect !== '1'"
                                        :background-color="
                                          form.hasBadEffect !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.badEffect"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <!-- Card 6 -->
                        <v-card outlined class="mt-8">
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer">Investigators</span>
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span
                                        ><b
                                          >12. มีการเปลี่ยนผู้วิจัยหลัก
                                          หรือผู้วิจัยร่วมในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่ ?
                                        </b></span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasChangeMainResearcher"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout pl-4>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span>(ถ้ามี สรุปสั้นๆ)</span>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="
                                          form.hasChangeMainResearcher !== '1'
                                        "
                                        :background-color="
                                          form.hasChangeMainResearcher !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.changeMainResearcher"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #fff"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex xs8 pr-4 style="text-align: left">
                                      <span
                                        ><b
                                          >13.
                                          มีการเปลี่ยนแปลงฐานะหรือคุณสมบัติของผู้วิจัยในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่ ? </b
                                        >(ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="
                                          form.hasChangeResearcherProperty
                                        "
                                        hide-details
                                        row
                                      >
                                        <v-radio
                                          color="#39896B"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="
                                          form.hasChangeResearcherProperty !==
                                            '1'
                                        "
                                        :background-color="
                                          form.hasChangeResearcherProperty !==
                                          '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.changeResearcherProperty"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <!-- Card 7 -->
                        <v-card outlined class="mt-8">
                          <v-layout>
                            <v-flex
                              xs1
                              style="background-color: #efeae7; font-size: 24px"
                            >
                              <span class="textAlignVer">Other issues</span>
                            </v-flex>
                            <v-flex>
                              <!-- row 1 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #39896b"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      xs8
                                      style="text-align: left; color: white"
                                    >
                                      <span
                                        ><b
                                          >14. มีข้อกังวลของผู้วิจัย
                                          เกี่ยวกับโครงการวิจัยในช่วงการรับรองของ
                                          คณะอนุกรรมการฯหรือไม่? </b
                                        >(ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="form.hasConcern"
                                        hide-details
                                        row
                                        dark
                                      >
                                        <v-radio
                                          color="#fff"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#fff"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="form.hasConcern !== '1'"
                                        :background-color="
                                          form.hasConcern !== '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.concern"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <!-- row 2 -->
                              <v-layout
                                py-6
                                px-6
                                style="background-color: #fff"
                              >
                                <v-flex>
                                  <v-layout>
                                    <v-flex xs8 pr-4 style="text-align: left">
                                      <span
                                        ><b
                                          >15.
                                          มีข้อมูลจากคณะกรรมการกำกับดูแลโครงการวิจัย
                                          (data monitoring- committees, DMCs)
                                          ในช่วงการรับรองของคณะอนุกรรมการฯหรือไม่? </b
                                        >(ถ้ามี สรุปสั้นๆ)</span
                                      >
                                    </v-flex>
                                    <v-flex xs4 mt-n5 style="text-align: right">
                                      <v-radio-group
                                        readonly
                                        v-model="
                                          form.hasInformationFromCommittee
                                        "
                                        hide-details
                                        row
                                      >
                                        <v-radio
                                          color="#39896B"
                                          label="มี"
                                          value="1"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไม่มี"
                                          value="2"
                                        ></v-radio>
                                        <v-radio
                                          color="#39896B"
                                          label="ไมเกี่ยวข้อง"
                                          value="3"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout px-4 mt-4>
                                    <v-flex>
                                      <TextareaForm
                                        hide-detail
                                        :rows="4"
                                        :disabled="
                                          form.hasInformationFromCommittee !==
                                            '1'
                                        "
                                        :background-color="
                                          form.hasInformationFromCommittee !==
                                          '1'
                                            ? '#E4E4E4'
                                            : '#FBF6F3'
                                        "
                                        :model="form.informationFromCommittee"
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>

                    <!-- row 5 -->
                    <v-layout my-6 px-12>
                      <v-flex style="font-weight: bold; text-align: left">
                        <span>สรุปข้อมูลเพิ่มเติม</span>
                      </v-flex>
                    </v-layout>
                    <v-layout px-12>
                      <v-flex>
                        <TextareaForm
                          :rows="10"
                          :model="form.summarize"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout class="my-12 px-12">
                      <v-flex>
                        <v-layout class="mb-8">
                          <v-flex>
                            <v-layout>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >หนังสือของหน่วยงาน :
                                </span>
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  v-if="agencyBook"
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open"
                                >
                                  {{ agencyBook }}
                                </span>
                                <span
                                  v-else
                                  class="text-start"
                                  style="font-size: 12px; color: #cc3d45"
                                >
                                  -
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >เลขหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  readonly
                                  hide-detail
                                  :model="form.bookNumber"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mx-4 font-weight-bold"
                                shrink
                                >วันที่หนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  readonly
                                  :model="form.bookDate"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6 mt-5>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >หน่วยงานที่ออกหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  :model="form.instituteBook"
                                  @update-data="
                                    updateData('instituteBook', $event)
                                  "
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                            <div
                              v-for="(input, k) in form.fileOther"
                              :key="'d' + k"
                              class="my-5"
                            >
                              <v-layout>
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      shrink
                                      mr-4
                                      pt-2
                                      style="text-align: right;font-weight: bold;"
                                    >
                                      <span>ชื่อไฟล์</span>
                                    </v-flex>
                                    <v-flex xs2>
                                      <textfield-form
                                        hide-detail
                                        :model="input.title"
                                      ></textfield-form>
                                    </v-flex>
                                    <v-flex v-if="input.filePath"
                                      ><a
                                        :href="input.filePath"
                                        target="_blank"
                                        style="color: #3e7662;text-align: center"
                                        class="link-hover"
                                      >
                                        <p>ไฟล์ที่อัพโหลด: {{ input.file }}</p>
                                      </a>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout> </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <!-- row 6 -->
                    <v-layout my-6 px-12>
                      <v-flex
                        mr-12
                        xs5
                        style="text-align: left"
                        class="text-field-center"
                      >
                        <textfield-form-append
                          css="font-weight: bold;"
                          label="ผู้วิจัย"
                          icon="edit"
                          :model="form.signature"
                          readonly
                          hide-detail
                        />
                      </v-flex>
                      <v-flex shrink pt-2 mr-4 style="font-weight: bold">
                        <span>วันที่</span>
                      </v-flex>
                      <v-flex xs3>
                        <textfield-form
                          hide-detail
                          :model="date"
                          readonly
                        ></textfield-form>
                      </v-flex>
                    </v-layout>
                    <v-layout mt-6 px-12>
                      <v-flex xs5>
                        <v-layout justify-center>
                          <v-flex shrink style="font-weight: bold">
                            <span>(</span>
                          </v-flex>
                          <v-flex xs8 mx-2 mt-n3 class="text-field-center">
                            <textfield-form-append
                              :model="form.signature"
                              readonly
                            />
                          </v-flex>
                          <v-flex shrink style="font-weight: bold">
                            <span>)</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: 30px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>Note</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex style="padding-left: 32px; padding-right: 32px">
                        <textarea-form
                          @update-data="updateData('noteDetail', $event)"
                          :model="form.noteDetail"
                          :rows="5"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: -35px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>การตรวจสอบ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-left: 32px; margin-top: -15px">
                      <span style="font-weight: bold; padding-top: 19px"
                        >วันที่ผู้วิจัยรายงาน</span
                      >
                      <v-col cols="2" class="text-end text-field-center">
                        <DateInputForm
                          :model="researcherReportDate"
                          @update-data="
                            updateData('researcherReportDate', $event)
                          "
                          style="font-weight: bold"
                        ></DateInputForm>
                      </v-col>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: left">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="$router.go(-1)"
                          >ย้อนกลับ</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex mb-12 style="text-align: right">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="saveEdit()"
                          ><v-icon>add</v-icon>บันทึกเพื่อแก้ไข</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../../components/input/TextfieldForm";
import TextareaForm from "../../../components/input/TextareaForm";
import DateInputForm from "../../../components/input/DateInputForm";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  computed: {
    ...mapState({
      researchID: (state) => state.formRF.researchID,
    }),
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    selected: [],
    dialog: false,
    form: {
      fileOther: [],
      hasStartDay: false,
      noteDetail: "",
      researcherReportDate: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      lastDay: "",
      startDay: "",
      endDay: "",
      reportDate: "",
      reportTime: "",
      wantRenew: "",
      hasOther: false,
      hasPlan: false,
      plan: "",
      hasScreen: false,
      screen: "",
      hasResearching: false,
      researching: "",
      hasFollowing: false,
      following: "",
      hasWithdraw: false,
      withdraw: "",
      hasFinish: false,
      finish: "",
      hasWithdrawVolunteer: "2",
      withdrawVolunteer: "",
      hasEdit: "2",
      edit: "",
      hasEditBrochure: "2",
      hasNewInformation: "2",
      newInformation: "",
      hasIssue: "2",
      issue: "",
      hasChangeRatio: "2",
      changeRatio: "",
      hasChangeDocument: "2",
      changeDocument: "",
      hasConsentIssue: "2",
      consentIssue: "",
      hasComplaint: "2",
      complaint: "",
      hasBadEffect: "2",
      badEffect: "",
      hasChangeMainResearcher: "2",
      changeMainResearcher: "",
      hasChangeResearcherProperty: "2",
      changeResearcherProperty: "",
      hasConcern: "2",
      concern: "",
      hasInformationFromCommittee: "2",
      informationFromCommittee: "",
      summarize: "",
      instituteBook: "",
      agencyBook: "",
      bookNumber: "",
      bookDate: "",

      signature: "",
      date: "",
    },
    status: "",
    researcherReportDate: "",
    userID: "",
    lastDay: "",
    startDay: "",
    endDay: "",
    reportDate: "",
    date: "",
    agencyBook: "",
    agencyBookLink: "",
  }),
  created() {
    this.getRF03();
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function(element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function(element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function(element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function(element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function(element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function(element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function(error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function() {
            await document
              .querySelectorAll("button")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    saveEdit() {
      Swal.fire({
        title: "คุณต้องการบันทึกเพื่อแก้ไขหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึกเพื่อแก้ไข",
      }).then((result) => {
        if (result.value) {
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;

          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveEditRF03", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกเพื่อแก้ไขสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/verify-rf");
              });
              console.log("res", res);

              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    updateData(name, val) {
      if (name === "researcherReportDate") {
        this.researcherReportDate = this.changeDate(val.date);
        this.form.researcherReportDate = val.date;
      }
      if (name === "noteDetail") {
        this.form.noteDetail = val;
      }
    },
    open() {
      window.open(this.agencyBookLink);
    },
    changeDate(val) {
      if (val != null) {
        //change date start
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return null;
      }
    },
    getRF03() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF03", this.$route.query.rfID)
        .then((res) => {
          console.log("res", res);
          this.form.fileOther = res.fileOther ?? [];
          this.form.hasStartDay = res.hasStartDay == 1 ? true : false;
          this.form.instituteBook = res.instituteBook;
          this.status = res.status;
          this.form.noteDetail = res.noteDetail;
          this.form.researcherReportDate = res.noteDetailDate;
          this.researcherReportDate = this.changeDate(res.noteDetailDate);
          this.form.researchCode = res.researchCode;
          this.form.firstName = res.firstName;
          this.form.lastName = res.lastName;
          this.form.researchName = res.researchName;
          this.form.lastDay = res.lastDay;
          this.lastDay = res.lastDay ? this.changeDate(res.lastDay) : "";
          this.form.startDay = res.startDay;
          this.startDay = res.startDay ? this.changeDate(res.startDay) : "";
          this.form.endDay = res.endDay;
          this.endDay = res.endDay ? this.changeDate(res.endDay) : "";
          this.form.reportDate = res.reportDate;
          this.reportDate = res.reportDate
            ? this.changeDate(res.reportDate)
            : "";
          this.form.reportTime = res.reportTime
            ? res.reportTime.toString()
            : "";
          this.form.wantRenew = res.wantRenew ? res.wantRenew.toString() : "";
          this.form.hasOther = res.hasOther ? res.hasOther.toString() : "";
          this.form.hasPlan = res.hasPlan;
          this.form.plan = res.plan ? res.plan.toString() : "";
          this.form.hasScreen = res.hasScreen;
          this.form.screen = res.screen ? res.screen.toString() : "";
          this.form.hasResearching = res.hasResearching;
          this.form.researching = res.researching;
          this.form.hasFollowing = res.hasFollowing
            ? res.hasFollowing.toString()
            : "";
          this.form.following = res.following;
          this.form.hasWithdraw = res.hasWithdraw;
          this.form.withdraw = res.withdraw ? res.withdraw.toString() : "";
          this.form.hasFinish = res.hasFinish ? res.hasFinish.toString() : "";
          this.form.finish = res.finish ? res.finish.toString() : "";
          this.form.hasWithdrawVolunteer = res.hasWithdrawVolunteer
            ? res.hasWithdrawVolunteer.toString()
            : "";
          this.form.withdrawVolunteer = res.withdrawVolunteer;
          this.form.hasEdit = res.hasEdit ? res.hasEdit.toString() : "";
          this.form.edit = res.edit;
          this.form.hasEditBrochure = res.hasEditBrochure
            ? res.hasEditBrochure.toString()
            : "";
          this.form.hasNewInformation = res.hasNewInformation
            ? res.hasNewInformation.toString()
            : "";
          this.form.newInformation = res.newInformation
            ? res.newInformation.toString()
            : "";
          this.form.hasIssue = res.hasIssue ? res.hasIssue.toString() : "";
          this.form.issue = res.issue;
          this.form.hasChangeRatio = res.hasChangeRatio
            ? res.hasChangeRatio.toString()
            : "";
          this.form.changeRatio = res.changeRatio;
          this.form.hasChangeDocument = res.hasChangeDocument
            ? res.hasChangeDocument.toString()
            : "";
          this.form.changeDocument = res.changeDocument
            ? res.changeDocument.toString()
            : "";
          this.form.hasConsentIssue = res.hasConsentIssue
            ? res.hasConsentIssue.toString()
            : "";
          this.form.consentIssue = res.consentIssue;
          this.form.hasComplaint = res.hasComplaint
            ? res.hasComplaint.toString()
            : "";
          this.form.complaint = res.complaint;
          this.form.hasBadEffect = res.hasBadEffect
            ? res.hasBadEffect.toString()
            : "";
          this.form.badEffect = res.badEffect;
          this.form.hasChangeMainResearcher = res.hasChangeMainResearcher
            ? res.hasChangeMainResearcher.toString()
            : "";
          this.form.changeMainResearcher = res.changeMainResearcher;
          this.form.hasChangeResearcherProperty = res.hasChangeResearcherProperty
            ? res.hasChangeResearcherProperty.toString()
            : "";
          this.form.changeResearcherProperty = res.changeResearcherProperty;
          this.form.hasConcern = res.hasConcern
            ? res.hasConcern.toString()
            : "";
          this.form.concern = res.concern;
          this.form.hasInformationFromCommittee = res.hasInformationFromCommittee
            ? res.hasInformationFromCommittee.toString()
            : "";
          this.form.informationFromCommittee = res.informationFromCommittee;
          this.form.summarize = res.summarize;

          this.agencyBookLink = res.agencyBookPath;
          this.agencyBook = res.agencyBook;
          this.form.bookNumber = res.bookNumber;
          this.form.bookDate = !res.bookDate
            ? ""
            : this.changeDate(res.bookDate);

          this.form.signature = res.signature;
          this.form.date = res.date;
          this.date = res.date ? this.changeDate(res.date) : "";
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
.color-label-checkbox {
  label.v-label.theme--light {
    color: #3e7662;
  }
}
.textAlignVer {
  -moz-transform-origin: 0 50%;
  -moz-transform: rotate(-90deg) translate(-50%, 50%);
  -webkit-transform-origin: 0 50%;
  -webkit-transform: rotate(-90deg) translate(-50%, 50%);
  -o-transform-origin: 0 50%;
  -o-transform: rotate(-90deg) translate(-50%, 50%);
  -ms-transform-origin: 0 50%;
  -ms-transform: rotate(-90deg) translate(-50%, 50%);
  transform-origin: 0 50%;
  transform: rotate(-90deg) translate(-50%, 50%);
  position: absolute;
  top: 0;
  bottom: 0;
  height: 2em; /* line-height of .wrapper div:first-child span */
  margin: auto;
  font-weight: bold;
  font-size: 1em;
  line-height: 2em; /* Copy to other locations */
  left: 15px;
}
</style>
